import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import "./cart-page-style.scss";
import { DeviceContext, deviceType } from '@providers';

import Button from "@src/componentsNew/Buttons/Button";
import Typography from "@src/componentsNew/Typography/Typography";
import GlobalStoreInfo from "@src/componentsNew/GlobalStore/GlobalStoreInfo";
import CartErrorsAlert from "@src/componentsNew/Cart/CartErrorsAlert";
import CartChange from "@src/componentsNew/Cart/CartChange";
import CartLines from "@src/componentsNew/Cart/CartLines";
import CartSummary from "@src/componentsNew/Cart/CartSummary";
import EmptyCart from "@src/componentsNew/Cart/EmptyCart";
import WishlistIcon from "@src/componentsNew/Icons/Icons/WishlistIcon";
import MobileCustomHeader from "@src/componentsNew/Header/CustomHeader/MobileCustomHeader";

import {
  CartSubCartsType,
  CartSubCartsLinesType,
  CartShippingPriceType,
  CartTotalWeightSelectedType
} from "@src/utils/types";
import { checkoutQuery_checkout_subcarts_lines } from "@src/components/pages/CheckoutPage/__generated__/checkoutQuery";

import { wishListUrl } from "@src/app/routes";

interface IProps {
  activeCart: 'maccaron' | 'mgs';
  loading: boolean;
  checkedStatesArray: boolean[][];
  isAllChecked: boolean;
  activeCartLineCount: number;
  inActiveCartLineCount: number;
  selectedLineCount: number;
  subcarts: (CartSubCartsType | null)[] | null;
  freebies: (CartSubCartsLinesType | checkoutQuery_checkout_subcarts_lines | null)[];
  errorMessages: any;
  totalPrice: number;
  totalDiscount: number;
  shippingPrice: CartShippingPriceType;
  isSomeChecked: boolean;
  totalWeightSelected: CartTotalWeightSelectedType;
  selectedProductIDs: string[];
  updateCartLine: any;
  deleteCartLine: any;
  cartLineToWishlist: any;
  onClickChangeCartType: any;
  onClickSelectAllCheckbox: any;
  onClickRemoveAllButton: any;
  onClickCheckoutButton: any;
}

const Cart = ({
  activeCart,
  loading,
  checkedStatesArray,
  isAllChecked,
  activeCartLineCount,
  inActiveCartLineCount,
  selectedLineCount,
  subcarts,
  freebies,
  errorMessages,
  totalPrice,
  totalDiscount,
  shippingPrice,
  isSomeChecked,
  totalWeightSelected,
  selectedProductIDs,
  updateCartLine,
  deleteCartLine,
  cartLineToWishlist,
  onClickChangeCartType,
  onClickSelectAllCheckbox,
  onClickRemoveAllButton,
  onClickCheckoutButton
}: IProps) => {
  const history = useHistory();
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    <div id="cart-page-wrapper" className={`${isMobile ? 'mobile' : ''} ${subcarts?.length > 0 ? 'pb' : ''}`}>
      {
        isMobile && (
          <MobileCustomHeader
            type="center"
            isShowBackBtn={true}
            pageTitle="Shopping Bag"
            pageTitleVariant="h7"
            pageTitleComponent="h3"
            rightChild={
              <WishlistIcon onClick={() => history.push(wishListUrl)} />
            }
          />
        )
      }

      {
        (isMobile && activeCartLineCount === 0 && inActiveCartLineCount === 0) ? (
          <EmptyCart />
        ) : (
          <div className={`cart-content-container ${isMobile ? 'mobile' : ''}`}>
            {
              isMobile && (
                <Typography cName="mgs-info-text" variant="caption" component="p" style={{ color: "#666666" }}>
                  MGS cannot be checked out with Maccaron products.
                </Typography>
              )
            }
            <div className={`cart-lines-wrapper ${isMobile ? 'mobile' : ''}`}>
              <CartChange hasBorder={true} activeCart={activeCart} lineCount={inActiveCartLineCount} onClickHandler={() => onClickChangeCartType(activeCart)} />

              {
                errorMessages?.length > 0 && (
                  <CartErrorsAlert errorMessages={errorMessages} />
                )
              }

              <div className={`gradiant-border-wrapper ${activeCart} ${isMobile ? "mobile" : ""}`}>
                <div className={`cart-left-side ${isMobile ? "mobile" : ""}`}>
                  <CartChange hasBorder={false} activeCart={activeCart} lineCount={activeCartLineCount} onClickHandler={() => onClickChangeCartType(activeCart)} />

                  {
                    checkedStatesArray?.length > 0 ? (
                      <>
                        <div className={`all-button-wrapper ${isMobile ? 'mobile' : ''}`}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                className={`sellect-all-checkbox ${activeCart}`}
                                disabled={loading}
                                checked={isAllChecked}
                                onChange={onClickSelectAllCheckbox} />
                            }
                            label={
                              <Typography variant={isMobile ? "body3" : "body2"} component="span" style={{ color: isMobile ? "#212121" : "#666666" }}>
                                {`Select All (${selectedLineCount}/${activeCartLineCount})`}
                              </Typography>
                            }
                          />

                          <Button
                            cName="remove-all-button"
                            variant="outlined"
                            size="small"
                            onClick={onClickRemoveAllButton}
                            disabled={checkedStatesArray?.length === 0 || loading}>
                            Remove Selected Items
                          </Button>
                        </div>

                        <CartLines
                          activeCart={activeCart}
                          loading={loading}
                          subcarts={subcarts}
                          freebies={freebies}
                          updateCartLine={updateCartLine}
                          deleteCartLine={deleteCartLine}
                          cartLineToWishlist={cartLineToWishlist}
                        />
                      </>
                    ) : (
                      <EmptyCart />
                    )
                  }
                </div>
              </div>
            </div>

            {
              checkedStatesArray?.length > 0 ? (
                <CartSummary
                  activeCart={activeCart}
                  loading={loading}
                  totalPrice={totalPrice}
                  totalDiscount={totalDiscount}
                  shippingPrice={shippingPrice}
                  isSomeChecked={isSomeChecked}
                  totalWeightSelected={totalWeightSelected}
                  selectedProductIDs={selectedProductIDs}
                  handleClick={onClickCheckoutButton}
                />
              ) : null
            }
          </div>
        )
      }
    </div>
  );
};

export default Cart;
